import index from './index/index.vue'
export default {
  index
}
